import React, { useContext, useState } from "react";
import TableSimple from "../../../components/Dynamic/TableSimple";
import { DF_OT0011Context } from "../context";
import { useEffect } from "react";
import BizinBackend from "../../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";
import withRouter from "../../../components/Common/withRouter";
import CardContext from "../../../components/Common/CardContext";
import useGetHeightPage from "../../../Hooks/useGetHeightPage";
import { Alert } from "reactstrap";
import { Skeleton } from "primereact/skeleton";

const DF_OT0011A = (props) => {
  document.title = "Defender | Selecionar Itens";
  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);
  const [paramsOnFilter, setParamsOnFilter] = React.useState([]);
  const csrfToken = useGetCsrfToken();
  const [listaItens, setListaItens] = useState([]);
  const [listaItensContext, setListaItensContext] = useState([]);
  const [alertText, setAlertText] = useState("");
  const [itemsChanged, setItemsChanged] = useState([]);
  const [idSchedule, setIdSchedule] = useState(null);
  const [payloadListSchedule, setPayloadListSchedule] = useState({});
  const [listPreSchedules, setListPreSchedules] = useState([]);

  const [step, setStep] = useState(1);

  const { access_token, userProfile } = useSelector((state) => ({
    access_token: state.login.user?.access_token,
    userProfile: state.login.profile,
  }));

  if (!parseParams.get("ID_Arquivo")) return;

  const handleGetData = async () => {
    try {
      const resp = await BizinBackend.executeProcedure(
        { 1: parseParams.get("ID_Arquivo") },
        "FRONT_Workspace_DF_OT0011_Lista_Itens_Pedido",
        csrfToken,
        access_token,
      );
      if (resp.resultset_1.length > 0) setListaItensContext(resp.resultset_1);
      if (resp.resultset_2.length > 0) setAlertText(resp.resultset_2[0]?.Valor);
      if (resp.resultset_3.length > 0) setListaItens(resp.resultset_3);
    } catch (error) {
      console.log(
        "erro ao carregar SRM_Pre_Agendamento_Lista_Itens_Pedido",
        error,
      );
    }
  };

  const handleGetListPreSchedules = async () => {
    try {
      const resp = await BizinBackend.executeProcedure(
        { 1: userProfile.ID_Usuario, 2: "pt-BR", 3: idSchedule },
        "FRONT_Workspace_DF_OT0011_Lista_Itens_Pre_Agenda",
        csrfToken,
        access_token,
      );
      if (resp.resultset_1.length > 0 || resp.resultset_2.length > 0)
        setPayloadListSchedule(resp);
      else setPayloadListSchedule([]);
    } catch (error) {
      console.log(
        "erro ao carregar SRM_Pre_Agendamento_Lista_Itens_Pedido",
        error,
      );
    }
  };

  const handleGetListSchedulesValidated = async () => {
    try {
      const resp = await BizinBackend.executeProcedure(
        { 1: idSchedule },
        "SRM_Pre_Agendamento_Validacao",
        csrfToken,
        access_token,
      );
      if (resp.length > 0) setListPreSchedules(resp);
    } catch (error) {
      console.log(
        "erro ao carregar SRM_Pre_Agendamento_Lista_Itens_Pedido",
        error,
      );
    }
  };

  const handleCreateSchedule = async (payload = {}, idAgendamento = null) => {
    try {
      const resp = await BizinBackend.executeProcedure(
        {
          1: idAgendamento, // ID_Agendamento,
          2: userProfile.ID_Usuario, // ID_Usuario
          3: payload?.ID_Empresa_Origem, //ID_Empresa_Origem
          4: payload?.ID_Empresa_Destino, //ID_Empresa_Destino
          5: payload?.ID_Local_Entrega, //ID_Local_Entrega
          6: payload?.ID_Tipo_Veiculo, //ID_Tipo_Veiculo
          7: payload?.ID_Tipo_Entrega, //ID_Tipo_Entrega
          8: payload?.ID_Categoria, //ID_Categoria
          9: payload?.Data_Agendamento_Previsto, //Data_Agendamento_Previsto
          10: payload?.ID_Arquivo, //ID_Arquivo
          11: payload?.Numero_Pedido, //Numero_Pedido
          12: payload?.Numero_Item, //Numero_Item
          13: payload?.Data_Entrega
            ? new Date(payload?.Data_Entrega)
                .toLocaleDateString()
                .split("/")
                .reverse()
                .join("-")
            : null, //Data_Entrega
          14: payload?.Quantidade_Pedida, //Quantidade_Pedida
          15: payload?.Quantidade_Faturada, //Quantidade_Faturada
          16: payload?.Quantidade_Saldo_Faturamento, //Quantidade_Saldo_Faturamento
          17: payload?.Quantidade_Pre_Agendada, //Quantidade_Pre_Agendada
          18: payload?.Quantidade_Disponivel_Pre_Agenda, //Quantidade_Disponivel_Pre_Agenda
          19: payload?.Valor_Unitario_Liquido, //Valor_Unitario_Liquido
          20: payload?.Valor_Unitario_Bruto, //Valor_Unitario_Bruto
        },
        "SRM_Pre_Agendamento_Criar",
        csrfToken,
        access_token,
      );

      if (resp[0] && resp[0]?.ID_Agendamento)
        setIdSchedule(resp[0]?.ID_Agendamento);
    } catch (error) {
      console.log("erro ao criar pre-agendamento", error);
    }
  };

  const handleDeletePreSchedule = async (payload = {}) => {
    if (payload?.config && payload?.config?.type === "EXEC_PROC") {
      const params = payload?.config?.procParams;
      try {
        const resp = await BizinBackend.executeProcedure(
          {
            1: userProfile.ID_Usuario,
            2: "pt-BR",
            3: idSchedule, // ID_Agendamento,
            4: params[0]["Numero_Pedido"] || "",
            5: params[0]["Numero_Item"] || "",
          },
          "FRONT_Workspace_DF_OT0011_Pre_Agendamento_Deleta_Documento_Item",
          csrfToken,
          access_token,
        );

        if (resp?.success) handleGetListPreSchedules();
      } catch (error) {
        console.log("erro ao deletar pre-agendamento", error);
      }
    }
  };

  const handleItemsChanged = async () => {
    if (itemsChanged.length > 0) {
      let idAgendamento = null;
      const item = itemsChanged[0];
      await handleCreateSchedule(item, null);
    }
  };

  const handleListScheduleValidated = async () => {
    await handleGetListSchedulesValidated();
    setStep(3);
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useGetHeightPage();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (idSchedule) {
      itemsChanged.shift();
      const promises = [];
      if (itemsChanged.length > 0) {
        itemsChanged.forEach((item) => {
          promises.push(handleCreateSchedule(item, idSchedule));
        });
        if (promises.length > 0)
          Promise.all(promises)
            .then(() => {})
            .finally(() => {
              setStep(2);
            });
      } else setStep(2);
    }
    return;
  }, [idSchedule]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    switch (step) {
      case 1:
        setPayloadListSchedule([]);
        break;
      case 2:
        handleGetListPreSchedules();
        break;
    }
    return;
  }, [step]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    handleGetData();
  }, []);

  return (
    <div className="page-content p-0">
      {step === 3 && (
        <div className="row p-0">
          <div className="col-12">
            <p className="font-size-20 fw-semibold text-color-azul1">
              Validação do Pré-agendamento
            </p>
          </div>
          <div className="col-12">
            <TableSimple
              dataKey={"id_resultado"}
              data={listPreSchedules || []}
              columnsList={[
                { field: "id_resultado", header: "" },
                { field: "ID_Tipo_Validacao", header: "Regra", sort: true },
                { field: "tipo_mensagem", header: "Tipo Mensagem", sort: true },
                { field: "mensagem", header: "Mensagem", sort: true },
              ]}
            />
          </div>
          <div className="d-flex col justify-content-end my-3 gap-3">
            <button
              className="btn btn-primary-dark text-white font-size-16 fw-semibold"
              onClick={() => {
                if (window.self !== window.top)
                  window.parent.location.href = `/DF_OT0011?ID_Agendamento=${idSchedule}`;
              }}
            >
              Próximo
            </button>
          </div>
        </div>
      )}

      {step === 2 && payloadListSchedule && (
        <div className="row p-0">
          {payloadListSchedule?.resultset_1?.length > 0 && (
            <div className="col-12 mb-3">
              <CardContext
                data={payloadListSchedule?.resultset_1.map((item) => {
                  item.label = item.Coluna;
                  item.value = item.Valor;
                  return item;
                })}
              />
            </div>
          )}
          <div className="col-12">
            <p className="font-size-20 fw-semibold text-color-azul1">
              Itens Selecionados para Pré-agendamento
            </p>
          </div>
          <div className="col-12">
            <TableSimple
              dataKey={"ID_Agendamento"}
              data={payloadListSchedule?.resultset_2 || []}
              columnsList={[
                { field: "Numero_Pedido", header: "Pedido", sort: true },
                { field: "Numero_Item", header: "Número Item", sort: true },
                { field: "Descricao", header: "Produto", sort: true },
                { field: "Unidade_Medida", header: "Un. Medida", sort: true },
                {
                  field: "Quantidade_Pedida",
                  header: "Qtd. p/Entrega",
                  sort: true,
                },
                { field: "Data_Entrega", header: "Data Entrega", sort: true },
                {
                  field: "Valor_Unitario_Liquido",
                  header: "Valor Item",
                  sort: true,
                },
                { field: "Coluna_Funcoes", header: "", hasImage: true },
              ]}
              enableDataSharing={true}
              callbackTriggers={handleDeletePreSchedule}
            />
          </div>
          <div className="d-flex col justify-content-end my-3 gap-3">
            <button
              className="btn btn-primary-dark text-white font-size-16 fw-semibold"
              onClick={() => setStep(step - 1)}
            >
              Voltar
            </button>
            <button
              className="btn btn-primary-dark text-white font-size-16 fw-semibold"
              onClick={handleListScheduleValidated}
            >
              Validar
            </button>
          </div>
        </div>
      )}

      {step === 1 && (
        <div className="row p-0">
          {listaItensContext.length > 0 ? (
            <div className="col-12 mb-3">
              <CardContext
                data={listaItensContext.map((item) => {
                  item.label = item.Coluna;
                  item.value = item.Valor;
                  return item;
                })}
              />
            </div>
          ) : (
            <Skeleton height={123} width={"100%"} className="mb-3 rounded-3" />
          )}
          {alertText ? (
            <div className="col-12 mb-3">
              <Alert
                className="border-0 m-0 h-100"
                style={{ backgroundColor: "#EC221F40" }}
              >
                <div className="row p-2 px-3">
                  <div className="col-auto p-0 pe-3">
                    <i
                      className={`fas fa-triangle-exclamation text-color-vermelho2 font-size-24`}
                    ></i>
                  </div>
                  <div className="col p-0">
                    <p className={`text-color-vermelho2 font-size-14 p-0 m-0`}>
                      {(alertText || "").trim()}
                    </p>
                  </div>
                </div>
              </Alert>
            </div>
          ) : (
            <Skeleton height={50} width={"100%"} className="mb-3 rounded-3" />
          )}

          <div className="col-12">
            <TableSimple
              dataKey={"Numero_Item"}
              data={listaItens}
              columnsList={[
                { field: "Numero_Item", header: "Item", sort: true },
                { field: "Nome_Produto", header: "Produto", sort: true },
                { field: "Codigo_Barras_Produto", header: "EAN", sort: true },
                {
                  field: "Codigo_Produto_Cliente",
                  header: "Cód.ERP",
                  sort: true,
                },
                {
                  field: "Valor_Unitario_Produto_Bruto",
                  header: "Vlr. Unit.",
                  sort: true,
                },
                {
                  field: "Valor_Total_Produto_Bruto",
                  header: "Vlr. Total",
                  sort: true,
                },
                { field: "Unidade_Medida", header: "UM", sort: true },
                { field: "Data_Entrega", header: "Data_Entrega", sort: true },
                { field: "Categoria_Produto", header: "Categoria", sort: true },
                { field: "Quantidade_Pedida", header: "Qtd. Ped.", sort: true },
                {
                  field: "Quantidade_Faturada",
                  header: "Qtd. Fat.",
                  sort: true,
                },
                {
                  field: "Quantidade_Saldo_Faturamento",
                  header: "Saldo Fat.",
                  sort: true,
                },
                {
                  field: "Quantidade_Disponivel_Pre_Agenda",
                  header: "Qtd. Agend.",
                  sort: true,
                },
                {
                  field: "Quantidade_Produto_Condicao",
                  header: "Saldo Agend.",
                  sort: true,
                },
                {
                  field: "Quantidade_Pre_Agendada",
                  input: true,
                  width: "10%",
                  header: "Qtd. a Entregar",
                },
              ]}
              enableCheckbox
              enableDataSharing={true}
              paramsOnFilter={paramsOnFilter}
              callbackCellEditComplete={(i) => {
                let updateItem = itemsChanged.map((item) => {
                  if (item.Numero_Item === i.Numero_Item) {
                    item.Quantidade_Pre_Agendada = i.Quantidade_Pre_Agendada;
                  }
                  return item;
                });
                if (
                  itemsChanged.find(
                    (item) => item.Numero_Item === i.Numero_Item,
                  )
                )
                  setItemsChanged([...updateItem]);
              }}
              callbackCheckboxSelected={setItemsChanged}
            />
          </div>
          <div className="d-flex col justify-content-end my-3">
            <button
              className="btn btn-primary-dark text-white font-size-16 fw-semibold"
              onClick={handleItemsChanged}
            >
              Adicionar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(DF_OT0011A);
